import warningIcon from "@assets/images/warning-red.svg";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import React from "react";

import useStyles from "./styles";

interface DialogDownloadWarningProps {
  onConfirm: () => void;
  open: boolean;
}

const DialogDownloadWarning: React.FC<DialogDownloadWarningProps> = ({
  onConfirm,
  open
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onConfirm}
      className={classes.root}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>
        <div className={classes.checkCircleimg}>
          <img
            src={warningIcon}
            alt="Warning Icon"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
        <MyTypography variant="h6" style={{ marginTop: "20px" }}>
          ไม่พบข้อมูลให้ Download
        </MyTypography>
      </DialogTitle>
      <DialogActions
        disableSpacing={false}
        style={{ justifyContent: "center" }}
      >
        <Button
          color={"primary"}
          variant={"contained"}
          className={classes.btnAction}
          fullWidth={true}
          onClick={onConfirm}
        >
          <MyTypography variant="body1">ปิดหน้าต่าง</MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDownloadWarning;
